// source: pbtypes/gen/skills/pan_tilt_handler_params.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.skills.PanTiltHandlerParams', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.skills.PanTiltHandlerParams = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.skills.PanTiltHandlerParams, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.skills.PanTiltHandlerParams.displayName = 'proto.skills.PanTiltHandlerParams';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.skills.PanTiltHandlerParams.prototype.toObject = function(opt_includeInstance) {
  return proto.skills.PanTiltHandlerParams.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.skills.PanTiltHandlerParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.PanTiltHandlerParams.toObject = function(includeInstance, msg) {
  var f, obj = {
dragVelocityFilterTimeConstant: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
gimbalPitchFilterTimeConstant: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
dragToEdgeActivationThreshold: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
imgXFieldOfView: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
imgYFieldOfView: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.skills.PanTiltHandlerParams}
 */
proto.skills.PanTiltHandlerParams.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.skills.PanTiltHandlerParams;
  return proto.skills.PanTiltHandlerParams.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.skills.PanTiltHandlerParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.skills.PanTiltHandlerParams}
 */
proto.skills.PanTiltHandlerParams.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDragVelocityFilterTimeConstant(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGimbalPitchFilterTimeConstant(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setDragToEdgeActivationThreshold(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setImgXFieldOfView(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setImgYFieldOfView(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.skills.PanTiltHandlerParams.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.skills.PanTiltHandlerParams.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.skills.PanTiltHandlerParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.skills.PanTiltHandlerParams.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDragVelocityFilterTimeConstant();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getGimbalPitchFilterTimeConstant();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getDragToEdgeActivationThreshold();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getImgXFieldOfView();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getImgYFieldOfView();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
};


/**
 * optional double drag_velocity_filter_time_constant = 1;
 * @return {number}
 */
proto.skills.PanTiltHandlerParams.prototype.getDragVelocityFilterTimeConstant = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.PanTiltHandlerParams} returns this
 */
proto.skills.PanTiltHandlerParams.prototype.setDragVelocityFilterTimeConstant = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double gimbal_pitch_filter_time_constant = 2;
 * @return {number}
 */
proto.skills.PanTiltHandlerParams.prototype.getGimbalPitchFilterTimeConstant = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.PanTiltHandlerParams} returns this
 */
proto.skills.PanTiltHandlerParams.prototype.setGimbalPitchFilterTimeConstant = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double drag_to_edge_activation_threshold = 3;
 * @return {number}
 */
proto.skills.PanTiltHandlerParams.prototype.getDragToEdgeActivationThreshold = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.PanTiltHandlerParams} returns this
 */
proto.skills.PanTiltHandlerParams.prototype.setDragToEdgeActivationThreshold = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double img_x_field_of_view = 4;
 * @return {number}
 */
proto.skills.PanTiltHandlerParams.prototype.getImgXFieldOfView = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.PanTiltHandlerParams} returns this
 */
proto.skills.PanTiltHandlerParams.prototype.setImgXFieldOfView = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double img_y_field_of_view = 5;
 * @return {number}
 */
proto.skills.PanTiltHandlerParams.prototype.getImgYFieldOfView = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.skills.PanTiltHandlerParams} returns this
 */
proto.skills.PanTiltHandlerParams.prototype.setImgYFieldOfView = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


goog.object.extend(exports, proto.skills);
